/** Production canonical host — auth lives in origin-scoped localStorage. */
export const CANONICAL_HOST = 'scoreclash.app';
/** Non-canonical alias that must redirect to CANONICAL_HOST. */
export const WWW_HOST = 'www.scoreclash.app';

/**
 * @param {{ hostname: string, pathname: string, search: string, hash: string }} locationLike
 * @returns {string | null}
 */
export function getCanonicalRedirectUrl(locationLike) {
  if (!locationLike || locationLike.hostname !== WWW_HOST) return null;
  const pathname = locationLike.pathname || '/';
  const search = locationLike.search || '';
  const hash = locationLike.hash || '';
  return `https://${CANONICAL_HOST}${pathname}${search}${hash}`;
}

/**
 * Force www → apex so there cannot be two independent sessions.
 * Clears www-origin storage before leaving so stale JWTs cannot linger.
 *
 * @param {{ hostname: string, pathname: string, search: string, hash: string }} [locationLike]
 * @param {(url: string) => void} [assign]
 * @returns {boolean} true when a redirect was started
 */
export function redirectToCanonicalHostIfNeeded(
  locationLike = typeof window !== 'undefined' ? window.location : null,
  assign = (url) => {
    window.location.replace(url);
  }
) {
  const url = getCanonicalRedirectUrl(locationLike);
  if (!url) return false;

  try {
    localStorage.clear();
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }

  assign(url);
  return true;
}
